import Moment from "moment";
export default [
    {
      key: "logDate",
      title: "Date",
      width: 120,
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.logDate
              ? Moment(row.rowData.logDate).format("MM/DD/YYYY HH:mm:ss A")
              : ""}
          </p>
        );
      },
    },
    {
      key: "logUser",
      title: "User",
      width: 120,
    },

    {
      key: "logType",
      title: "Log Type",
      width: 120,
    },
    {
      key: "logEntry",
      title: "Log Entry",
      width: 120,
    },
  ];

 export const  update_data=(obj:any)=>{
  const updated_array:any=[]
  Object.keys(obj)
  .reverse()
  .forEach(key=>{
    updated_array.push({
      'id':obj[key].id,
      'fleetDetailId':obj[key].fleetDetailId,
      'logTypeId':obj[key].logTypeId,
      'logDate':obj[key].logDate,
      'logType':obj[key].logType,
      'logEntry':obj[key].logEntry,
      'logUserId':obj[key].logUserId,
      'logUser':obj[key].logUserName
    })
  })
  return updated_array
} 